import * as React from 'react';
import { lastPageOffset, useNativeListState } from '@/components/interaction/interaction-scope';

/** Presentation only: the generated domain query still owns filtering, totals and authority. */
export function useContentList(key: string, pageSize: number) {
  const [state, update] = useNativeListState(key, { search: '', filters: {}, sort: 'native', offset: 0, pageSize });
  const setOffset = (offset: number) => update({ offset });
  return { state, update, offset: state.offset, setOffset };
}
export function usePageCorrection(query: { isSuccess: boolean; data?: { total?: number } }, offset: number, pageSize: number, setOffset: (offset: number) => void) {
  const total = query.data?.total;
  React.useEffect(() => {
    if (query.isSuccess && total !== undefined && offset > lastPageOffset(total, pageSize)) setOffset(lastPageOffset(total, pageSize));
  }, [query.isSuccess, total, offset, pageSize, setOffset]);
}
